import React from 'react';
import { Stack, Typography } from '@mui/material';
import Group from './Group';

const GroupList = ({ groups }) => (
  <Stack direction="column" justifyContent={groups.length > 0 ? 'flex-start' : 'center'} flexWrap="wrap" spacing={2}>
    {groups.length > 0
      ? groups.map(gruop => (
        <Group key={gruop.id} {...gruop}/>
      ))
      : <Typography variant="h3" style={{ textAlign: 'center' }}>Brak danych</Typography>}
  </Stack>
);

export default GroupList;
